module.exports = __webpack_public_path__ + "static/9-5a1d19df0ab27dc072518b6065c1088f.png";